import _Vue from "vue";
import axios, {Axios} from "axios";
import app from "@/main";
import {Mixins} from "@/plugins/uyap-plugin/takip_ac/Mixins";
import * as xml2js from "xml2js";
import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {store} from "@/store";
import {v4 as uuidv4} from 'uuid';
import {promptForPin, promptForPinSimple} from './utils/pin-modal';
import {showWarningModal, showErrorModal} from './utils/modal';

const imzaciUrl = 'https://imza.eicrapro.com:6090/'
const proxyBaseUrl = 'https://imza.eicrapro.com:';
const uyapSignerUrl = 'https://imza.eicrapro.com:6057';
const uyapSignerBedestenUrl = 'https://imza.eicrapro.com:6065';
const avukatBetaUrl = 'https://imza.eicrapro.com:6099';
const avukatUyapUrl = 'https://imza.eicrapro.com:6081';

// UTF-8 aware base64 decoder
function base64ToUtf8(value: string): string {
    try {
        const decoded = atob(value);
        const bytes = new Uint8Array(decoded.length);
        for (let i = 0; i < decoded.length; i++) {
            bytes[i] = decoded.charCodeAt(i);
        }
        // TextDecoder kullan (modern tarayıcılarda mevcut)
        if (typeof TextDecoder !== 'undefined') {
            const decoder = new TextDecoder('utf-8');
            return decoder.decode(bytes);
        }
        // Fallback: Manuel UTF-8 decode
        let result = '';
        let i = 0;
        while (i < bytes.length) {
            const byte1 = bytes[i++];
            if (byte1 < 0x80) {
                result += String.fromCharCode(byte1);
            } else if (byte1 < 0xE0) {
                const byte2 = bytes[i++];
                result += String.fromCharCode(((byte1 & 0x1F) << 6) | (byte2 & 0x3F));
            } else if (byte1 < 0xF0) {
                const byte2 = bytes[i++];
                const byte3 = bytes[i++];
                result += String.fromCharCode(((byte1 & 0x0F) << 12) | ((byte2 & 0x3F) << 6) | (byte3 & 0x3F));
            } else {
                const byte2 = bytes[i++];
                const byte3 = bytes[i++];
                const byte4 = bytes[i++];
                const codePoint = ((byte1 & 0x07) << 18) | ((byte2 & 0x3F) << 12) | ((byte3 & 0x3F) << 6) | (byte4 & 0x3F);
                result += String.fromCodePoint(codePoint);
            }
        }
        return result;
    } catch (_) {
        return value;
    }
}

export enum UYAP_PLATFORM_SOCKET {
    ARABULUCU_PORTAL = 6080,
    ARABULUCU_PORTAL_URL = "arabulucu.uyap.gov.tr",
    AVUKAT_PORTAL = 6081,
    AVUKAT_PORTAL_URL = "avukat.uyap.gov.tr",
}

class ImzaClient {
    simulator = false;
    imzaLoginWaiting = false;
    waitingFailMessage = "Bekleyen bir giriş isteği mevcut.";
    myuuid = uuidv4();
    licenseKey = "BuAGz2LA60J621IuCTSdeyn5mlhdgN3puHt/BQkiVVsV+m2AF8wJz0v9oYl6gtFSOl2z6ubbg9UePov9DXS41y/IVenLiphm2ydZHlcFSFOOEt/Rd5ze94MWdTb6Wrl/Q8Xd8/Nc1xcs6eij27alNcbur3doMbmM+Cw2t4FmoBokXbNULbJBILq85BJD4Snvx1+xp8aUtXha5fJn6amYymiwhbJzKBGZmGU3kIymDgu9heYGkSDVJaZF0kA14uQlKk1Y1HMyVykKkRNYZtQcEqX37/Mov4PCc3c44on3MQZe2J1ziz66NWJI6MxQSAPsH5vNBHsTkUjkUOgpoAEOhQ==";
    availableCardsPromise: Promise<any>|null = null;
    betaLoginPromise: Promise<any>|null = null;

    private ensureTcknInSession(): string | null {
        let t = sessionStorage.getItem('tckn');
        const isValid = (val: any) => typeof val === 'string' && /^\d{11}$/.test(val);
        if (!isValid(t)) {
            try {
                const s = store?.getters?.userData?.kimlik_no;
                if (isValid(String(s))) {
                    t = String(s);
                    sessionStorage.setItem('tckn', t);
                } else {
                    t = null;
                }
            } catch (_e) {
                t = null;
            }
        }
        return t;
    }

    setSimulator() {
        this.simulator = true;
    }

    heartbeat() {
        console.log('heartbeat() fonksiyonu başlatıldı');
        const xml = '<root><auth><token></token><hash></hash></auth><data></data></root>';
        return new Promise(async (s, f) => {
            if (this.simulator) {
                return s("");
            }
            try {
                let data = await axios.post(imzaciUrl + 'xml/heartbeat', {xml: xml}, {
                    withCredentials: true
                });
                return s(data);
            } catch (e) {
                //console.log('fail');
                return f(e);
            }
        });
    }
    async setApiCookiesToImza(){
        try{
            let tenant = await store.dispatch('tenantData');
            let apiType: string = "";
            switch (process.env.VUE_APP_API_TARGET) {
                case 'http://localhost':
                    apiType = "local";
                    break;
                case 'https://apicloudicra.neova.com.tr':
                    apiType = "neova";
                    break;
                case 'https://apicloudtest.zirve-bilgisayar.com':
                    apiType = "test"
                    break;
                case 'https://apibeta.zirve-bilgisayar.com':
                    apiType = "beta"
                    break;
                case 'https://apicloud.zirve-bilgisayar.com':
                    apiType = "canli"
                    break;
            }

            // Session storage'a TCKN'yi kaydet (imza doğrulama için)
            if (store.getters.userData && store.getters.userData.kimlik_no) {
                sessionStorage.setItem('tckn', store.getters.userData.kimlik_no);
                console.log('TCKN sessionStorage\'a kaydedildi:', store.getters.userData.kimlik_no);
            }

            const cookieSetUrl = encodeURI(proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL + '/setConfig?token=' + 'Bearer ' + store.getters.accessToken + '&tenant=' + JSON.stringify(tenant) + '&tckn=' + store.getters.userData.kimlik_no + '&apiType=' + apiType);
            await app.$uyap.SetCookie().run({url: cookieSetUrl});
            _Vue.prototype.$socket.client.emit("updateToken");
            return true;
        }catch (e) {
            throw new Error(e);
        }
    }


    async setCookieToImza() {
        if (window.sessionStorage.hasOwnProperty("INJECT_JSESSIONID")) {
            let jsessionId = window.sessionStorage.getItem("INJECT_JSESSIONID");
            const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/cookie?JSESSIONID=' + jsessionId + ';SameSite=None;Secure';
            await app.$uyap.SetCookie().run({url: cookieSetUrl});
        }
    }

    async changePlayerStatus(status: PlayerDurum) {
        const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/putTaskPlayerStatus?' + status;
        await app.$uyap.ChangePlayerStatus().run({url: cookieSetUrl});
    }

    async getPlayerStatus() {
        const cookieSetUrl = proxyBaseUrl + UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL.toString() + '/getTaskPlayerStatus';
        return await app.$uyap.ChangePlayerStatus().run({url: cookieSetUrl});
    }

    async login(uyapPlatform: UYAP_PLATFORM_SOCKET) {
        try {
            if (this.imzaLoginWaiting == true)
                throw new Error(this.waitingFailMessage);
            this.imzaLoginWaiting = true;
            let authorizationCodeResponse = await axios.post(imzaciUrl + 'xml/session');
            window.sessionStorage.setItem("uyapAuthorizationCode", authorizationCodeResponse.data);
            let platform = UYAP_PLATFORM_SOCKET.AVUKAT_PORTAL_URL;
            if (uyapPlatform == UYAP_PLATFORM_SOCKET.ARABULUCU_PORTAL)
                platform = UYAP_PLATFORM_SOCKET.ARABULUCU_PORTAL_URL;
            let uyapLoginResponse = await axios.get(imzaciUrl + 'uyapLogin?code=' + authorizationCodeResponse.data + '&platform=' + platform);
            let cookies = uyapLoginResponse.data;
            //@ts-ignore
            let jsessionId = cookies.find(c => c.indexOf("JSESSIONID") >= 0);
            const cookieSetUrl = proxyBaseUrl + uyapPlatform.toString() + '/cookie?' + cookies.join("; ") + ';SameSite=None;Secure';
            window.sessionStorage.setItem("JSESSIONID", jsessionId);
            app.$uyapHelper.setCookie("JSESSIONID", jsessionId.replace("JSESSIONID=", ""), 1);
            await app.$uyap.SetCookie().run({url: cookieSetUrl});
            app.$socket.client.emit("uyapcookies", {
                cookies: cookies,
            });
            let counter = 0;
            const checkSession = () => {
                app.$uyap.AvukatKisiselBilgileriSorgulama().run({}).then(avukat => {
                    this.imzaLoginWaiting = false;
                    app.$store.commit('setUyapAvukatBilgileri',avukat);
                    return avukat;
                }).catch((avukatErr) => {
                    // eslint-disable-next-line no-console
                    console.log("CATCH AVUKAT", avukatErr);
                    if (counter > 5) {
                        this.imzaLoginWaiting = false;
                        throw new Error('UYAP oturumuna erişilemedi.');
                    } else {
                        counter++;
                        window.setTimeout(() => {
                            checkSession();
                        }, 3000)
                    }
                })
            }
            checkSession();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log("imza login CATCH", e);
            this.imzaLoginWaiting = false;
            throw new Error(e.message);
        }
    }

    async betaLoginImzalayici() {
        try {
            //throw new Error("GÜNCELLEME YAPILIYOR");
            if (this.imzaLoginWaiting == true)
                throw new Error(this.waitingFailMessage);
            this.imzaLoginWaiting = true;

            const licenseKey = "hBx7PnsAGYo4q4QUSwDEQabM/Ky+bk2uxoKi2aIzBMw=";
            let certificatesResponse = await axios.post(uyapSignerUrl + "/certificates", {
                license : licenseKey
            });
            // eslint-disable-next-line no-console
            console.log(certificatesResponse);

            //certifikaları aldık 2 tane olabilir biz ilkini alıyoruz..
            let selectedCertificate = certificatesResponse.data.data[0].certs[0];
            let certificateResponse = await axios.post(uyapSignerUrl + "/certificate", {
                certificateId: selectedCertificate.id,//"x509-02000000-1fc3ce82e47ff4020caa4e0c9edd4a6bec4b4a5700",
                license:licenseKey,
                providerId : selectedCertificate.providerId
            });


            let tckn = selectedCertificate.subjectSerial;
            let serial = selectedCertificate.serial;
            // eslint-disable-next-line no-console
            console.log('Sertifika TCKN:', tckn);
            const sessionTcknRaw = this.ensureTcknInSession();
            console.log('SessionStorage TCKN:', sessionTcknRaw);
            console.log('Sertifika serial:', serial);

            // TCKN kontrolünü daha esnek yap - sessionStorage'da TCKN yoksa atla
            const normalize = (v: string | null | undefined) => v ? v.replace(/\D/g, '') : null;
            const sessionTckn = normalize(sessionTcknRaw);
            const certTckn = normalize(tckn);
            if (sessionTckn && certTckn && sessionTckn !== certTckn) {
                console.error('Normal İmza TCKN uyuşmazlığı! SessionStorage:', sessionTckn, 'Sertifika:', certTckn);
                throw {type: 'unauthorized', message: 'İzinsiz İmza'};
            } else if (!sessionTckn) {
                console.warn('SessionStorage\'da TCKN bulunamadı, normal imza kontrolü atlanıyor');
            } else {
                console.log('Normal imza TCKN kontrolü başarılı');
            }
            let pinCode = localStorage.getItem(serial);
            if (!pinCode || pinCode == "undefined" || pinCode == undefined) {
                const ownerInfo = selectedCertificate.issuer + " --- " + selectedCertificate.subject;
                const deger = await promptForPinSimple(ownerInfo);

                if (!deger) {
                    throw new Error('İmza işlemi iptal edildi');
                }
                localStorage.setItem(serial, deger);
                pinCode = deger;
            }

            //https://bedesten.adalet.gov.tr/izo/api/v1/sign/sign

            let bedestenSignResponse = await axios.post(uyapSignerBedestenUrl + "/izo/api/v1/sign/sign", {
                cert:certificateResponse.data.data,
                profile:"CAdES",
                subProfile:"BES",
                type:"ATTACHED",
                policy:"NONE",
                device:"TOKEN",
                counterSignature:"PARALLEL",
                documentB64:"QmlyIEfDvG4gSGVya2VzIEZlbmVyYmFoY2VsaSBPbGFjYWs=",
                validateAfter: true
            });

            let signResponse = await axios.post(uyapSignerUrl + "/sign", {
                certificateId:selectedCertificate.id,
                contentB64:bedestenSignResponse.data.data.dataToSign,
                license:licenseKey,
                password:pinCode,
                providerId:selectedCertificate.providerId,
            });

            let bedestenMergeResponse = await axios.post(uyapSignerBedestenUrl + "/izo/api/v1/sign/merge", {
                signedData:signResponse.data.data,
                txId:bedestenSignResponse.data.data.txId,
            });

            let newAxios = new Axios({
                withCredentials: true,
            });
            await newAxios.get(avukatUyapUrl+'/clearCookies');
            // set-cookie
            let setCookieRes = await newAxios.get(avukatUyapUrl+'/web1.uyap', {
                params: {
                    signature:bedestenMergeResponse.data.data.signature,
                    txId: bedestenMergeResponse.data.data.txId,
                }
            });
            window.sessionStorage.setItem("JSESSIONID", setCookieRes.headers.cookie);
            // kullanilmadigi icin kapatildi
            // let setCookieResData = JSON.parse(setCookieRes.data);
            await newAxios.post(avukatUyapUrl+'/login.uyap', {});
            let counter = 0;
            const checkSession = () => {
                app.$uyap.AvukatKisiselBilgileriSorgulama().run({}).then(avukat => {
                    this.imzaLoginWaiting = false;
                    app.$store.commit('setUyapAvukatBilgileri',avukat);
                    return avukat;
                }).catch((avukatErr) => {
                    // eslint-disable-next-line no-console
                    console.log("CATCH AVUKAT", avukatErr);
                    if (counter > 5) {
                        this.imzaLoginWaiting = false;
                        throw new Error('UYAP oturumuna erişilemedi.');
                    } else {
                        counter++;
                        window.setTimeout(() => {
                            checkSession();
                        }, 3000)
                    }
                })
            }
            checkSession();
            // let cookies = await newAxios.get(avukatUyapUrl+'/getCookies');
            // let cookiesArr = JSON.parse(cookies.data).cookies.split('; ');
            // let jsessionId = cookiesArr.find((x:string)=>x.includes('JSESSIONID'));
            // window.sessionStorage.setItem("JSESSIONID", jsessionId);
            // app.$uyapHelper.setCookie("JSESSIONID", jsessionId.replace("JSESSIONID=", ""), 1);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.log("ERROR", e);
            if (e?.type == "pin")
                localStorage.removeItem(e.serialNumber);
            if (e?.type == "unauthorized") {
                this.sendImzaMessage({
                    title: "İzinsiz İmza",
                    text: "Hesabınızda kayıtlı TC kimlik numarası ile e-İmza kartındaki TC kimlik numarası  uyuşmamaktadır. Lütfen kendi hesabınızla giriş yapın ve size ait e-İmza kartını kullanın. Sorunun devam ettiğini düşünüyorsanız, Cloud ekranında Ctrl + Shift + R tuşlarına basarak sayfayı yenileyebilir ve tekrar deneyebilirsiniz. ",
                    icon: "warning",
                    allowOutsideClick: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Tamam'
                });
            } else if (e.message && e.message.includes("Failed to execute 'atob'")) {
                this.sendImzaMessage({
                    title: "İmza Kartı Bulunamadı",
                    text: "İmza kartının bilgisayara takılı olduğundan ve sürücülerinin yüklü olduğundan emin olun.",
                    icon: "warning",
                    allowOutsideClick: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Tamam'
                })
            } else {
                this.sendImzaMessage({
                    title: e.message,
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Tamam'
                });
            }
            this.imzaLoginWaiting = false;
            throw new Error(e.message);
        }
    }

    sendImzaMessage(msg: any){
        _Vue.prototype.$socket.client.emit("imzaMessage",msg);
    }

    async checkArkSignerRunning(){
        try{
            await axios.get(uyapSignerUrl);
        }catch (e) {
            throw new Error("UYAP E-İmza Programı açık değil veya hata oluştu lütfen UYAP E-İmza Programını açınız.")
        }
    }


    private async sleeping(ms: number): Promise<void> {
        //console.log("sleeping...");
        await new Promise((res) => setTimeout(res, ms));
    }

    async availableCards(){
        try{
            if (this.availableCardsPromise) {
                return this.availableCardsPromise;
            }
            this.availableCardsPromise = (async () => {
                try {
                    //todo iam here sleeep koy surekli atmasin ayriyetten
                    await this.checkArkSignerRunning();
                    await this.sleeping(100);
                    this.myuuid = uuidv4();
                    let formData = new FormData();
                    let firsReqData = {
                        "action": "initialize",
                        "licenseKey": this.licenseKey,
                        "usedUrl": "https://avukatbeta.uyap.gov.tr/giris",
                        "transactionUUID": this.myuuid
                    };
                    formData.append('parameters', window.btoa(JSON.stringify(firsReqData)));
                    let firstRes = await axios.post(uyapSignerUrl, formData);
                    await this.sleeping(100);
                    let secondFormData = new FormData();
                    let secondReqData = {
                        "action": "listCardTypeAndSlots",
                        "licenseKey": this.licenseKey,
                        "usedUrl": "https://avukatbeta.uyap.gov.tr/giris",
                        "transactionUUID": this.myuuid,
                        "nonce": JSON.parse(firstRes.data.substring(1, firstRes.data.length-1))[0].nonce
                    };
                    secondFormData.append('parameters', window.btoa(JSON.stringify(secondReqData)));
                    let secondRes = await axios.post(uyapSignerUrl, secondFormData);
                    await this.sleeping(100);
                    let insertedCards = JSON.parse(secondRes.data.substring(1, secondRes.data.length-1));
                    //console.log("insertedCards",insertedCards);
                    let cardList = [];
                    let card: any;
                    for (card of insertedCards){
                        if(typeof card.slotId == "undefined"){
                            continue;
                        }
                        let thirdFormData = new FormData();
                        let thirdReqData = {
                            "library": window.atob(card.library),
                            "slotId": window.atob(card.slotId),
                            "action": "listSignerCertificatesAsJSON",
                            "licenseKey": this.licenseKey,
                            "usedUrl": "https://avukatbeta.uyap.gov.tr/giris",
                            "transactionUUID": this.myuuid,
                            "nonce": card.nonce
                        };
                        thirdFormData.append('parameters', window.btoa(JSON.stringify(thirdReqData)));
                        let thirdRes = await axios.post(uyapSignerUrl, thirdFormData);
                        await this.sleeping(100);
                        let availableCard = JSON.parse(thirdRes.data.substring(1, thirdRes.data.length-1))[0];
                        //console.log("availableCard",availableCard);
                        cardList.push({
                            insertedCard : card,
                            cardOwner : availableCard
                        });
                    }
                    //console.log("cardList",cardList);
                    store.commit('setAvailableCardList', cardList);
                    return cardList;

                } finally {
                    // İşlem bittiğinde lock’u sıfırla
                    this.availableCardsPromise = null;
                }
            })();

            // Promise’i döndür
            return this.availableCardsPromise;

        }catch (e) {
            console.log("e",e);
            this.sendImzaMessage({
                title: "UYAP IMZA UYGULAMASI HATA!",
                text:  e.message,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Tamam'
            });
        }
    }
    getPinCodes(){
        if(localStorage.hasOwnProperty("pinCodes")){
            //@ts-ignore
            return JSON.parse(localStorage.getItem("pinCodes"));
        }else{
            this.setPinCodes([]);
            return [];
        }
    }
    setPinCodes(val: any){
        localStorage.setItem("pinCodes",JSON.stringify(val));
    }
    async betaLogin() {

        // Eğer zaten çalışıyorsa mevcut Promise’i döndür
        if (this.betaLoginPromise) {
            return this.betaLoginPromise;
        }

        // Fonksiyonun gerçek işini yapan Promise'i oluştur
        this.betaLoginPromise = (async () => {
            try {
                if (this.imzaLoginWaiting == true)
                    throw new Error(this.waitingFailMessage);
                this.imzaLoginWaiting = true;
                let cardList = await this.availableCards();
                if (!Array.isArray(cardList) || cardList.length === 0) {
                    throw new Error("Takılı akıllı kart bulunamadı.");
                }
                const preferredSerial: string | null = store.getters.selectedCardSerial ?? null;
                let card = cardList.find((c: any) => c?.cardOwner?.serialNumber === preferredSerial);
                if (!card) {
                    card = cardList[0];
                }
                store.commit('setSelectedCardSerial', base64ToUtf8(card.cardOwner.serialNumber));
                await axios.post('https://imza.eicrapro.com:6090/focus');
                // TODO: buraya koşul koy user tckn thirdResData.subjectSerialNumber ile eşleşiyor eşleşiyor ise devam et
                // session stora tcknyi set et axios oradan çeksin
                // eslint-disable-next-line no-console

                //Object.keys(card.cardOwner).forEach(x=>{
                //@ts-ignore
                //    console.log('XXXXXX ----- CardOwner :' + x, base64ToUtf8(card.cardOwner[x]));
                //});

                console.log('Beta Login - Sertifika TCKN (base64):', card.cardOwner.subjectSerialNumber);
                console.log('Beta Login - Sertifika TCKN (decoded):', atob(card.cardOwner.subjectSerialNumber));
                const sessionTcknRaw = this.ensureTcknInSession();
                console.log('Beta Login - SessionStorage TCKN:', sessionTcknRaw);

                // TCKN kontrolünü daha esnek yap - sessionStorage'da TCKN yoksa atla
                const normalize = (v: string | null | undefined) => v ? v.replace(/\D/g, '') : null;
                const sessionTckn = normalize(sessionTcknRaw);
                const certTckn = normalize(atob(card.cardOwner.subjectSerialNumber));
                console.log("certTckn",certTckn);

                if (sessionTckn && certTckn && sessionTckn !== certTckn) {
                    console.error('TCKN uyuşmazlığı! SessionStorage:', sessionTckn, 'Sertifika:', certTckn);
                    throw {type: 'unauthorized', message: 'İzinsiz İmza'};
                } else if (!sessionTckn) {
                    console.warn('SessionStorage\'da TCKN bulunamadı, kontrol atlanıyor');
                } else {
                    console.log('TCKN kontrolü başarılı');
                }
                let pinCodes = this.getPinCodes();
                console.log("pinCodes",pinCodes);
                console.log("store.getters.selectedCardSerial",store.getters.selectedCardSerial);
                console.log("card.cardOwner.serialNumber",card.cardOwner.serialNumber);
                console.log("base64ToUtf8(card.cardOwner.serialNumber)",base64ToUtf8(card.cardOwner.serialNumber));

                let pinCode;
                //@ts-ignore
                const currentSerial = base64ToUtf8(card.cardOwner.serialNumber);
                let cardPin = pinCodes.find((item: any) => item.cardSerialNumber === currentSerial);
                console.log("cardPin",cardPin);
                if (!cardPin) {
                    const formValues = await promptForPin({
                        ownerName: base64ToUtf8(card.cardOwner.commonName),
                        title: 'İmza Pin Kodu',
                        rememberLabel: 'Otomatik oturum aç',
                        minLen: 4,
                        maxLen: 12
                    });

                    if (!formValues) {
                        throw new Error('İmza işlemi iptal edildi');
                    }

                    pinCode = formValues.pin;
                    const autoLoginEnabled = formValues.remember;

                    console.log('PIN:', pinCode);
                    console.log('Otomatik oturum aç:', autoLoginEnabled);

                    pinCodes.push({
                        cardOwnerName: base64ToUtf8(card.cardOwner.commonName),
                        cardSerialNumber: base64ToUtf8(card.cardOwner.serialNumber),
                        pinCode: pinCode,
                        autoLogin: autoLoginEnabled
                    });
                    this.setPinCodes(pinCodes);
                }else{
                    pinCode = cardPin.pinCode;
                }
                let newAxios = new Axios({
                    withCredentials: true,
                });
                await newAxios.get(avukatUyapUrl+'/clearCookies');
                let setCookieRes: any = {};
                try{
                    // set-cookie
                    setCookieRes = await newAxios.get(avukatUyapUrl+'/web.uyap', {
                        params: {
                            action:'initialize-signing',
                            signatureType: 1,
                            certificateBase64: app.$uyapHelper.hexToBase64(card.cardOwner.certificateHex)
                        }
                    });
                    if(setCookieRes.data.includes("DOCTYPE html") == true){
                        throw new Error("GİRİŞ İSTEĞİNİZ OLUMSUZ.AVUKAT UYAP ÜZERİNDE ÇALIŞMA YAPILMAKTADIR.");
                    }
                }catch (e) {
                    console.log("e",e)
                }

                window.sessionStorage.setItem("JSESSIONID", setCookieRes.headers.cookie);
                let setCookieResData = JSON.parse(setCookieRes.data);
                let fourthFormData = new FormData();
                let fourthReqData = {
                    "library": window.atob(card.insertedCard.library),
                    "slotId": window.atob(card.insertedCard.slotId),
                    "certSerialNumber": window.atob(card.cardOwner.serialNumber),
                    "dataBase64": setCookieResData.digestBase64,
                    "pincode": pinCode,
                    "addSigningTime": true,
                    "action": "signPKCS1Padding1.5",
                    "licenseKey": this.licenseKey,
                    "usedUrl": "https://avukatbeta.uyap.gov.tr/giris",
                    "transactionUUID": this.myuuid,
                    "nonce": card.cardOwner.nonce
                };
                fourthFormData.append('parameters', window.btoa(JSON.stringify(fourthReqData)));
                let fourthRes = await axios.post(uyapSignerUrl, fourthFormData);
                let fourthResData=JSON.parse(fourthRes.data.substring(1, fourthRes.data.length-1))[0];
                if (fourthResData.responseCode == "27") {
                    localStorage.removeItem(atob(card.cardOwner.serialNumber));
                    throw {type: 'pin', message: 'PIN Yanlış', serialNumber: window.atob(card.cardOwner.serialNumber)};
                }
                else if (fourthResData.responseCode == "16") {
                    throw {type: 'signatureLocked', message: 'İmza Kilitli', serialNumber: window.atob(card.cardOwner.serialNumber)};
                }
                await newAxios.get(avukatUyapUrl+'/web.uyap', {
                    params: {
                        signatureBase64: fourthResData.signature,
                        transactionUUID: setCookieResData.transactionUUID,
                        certificateBase64: card.cardOwner.commonName,
                        action:'finalize-signing'
                    }
                });
                await newAxios.post(avukatUyapUrl+'/login.uyap', {});
                let counter = 0;
                const checkSession = () => {
                    app.$uyap.AvukatKisiselBilgileriSorgulama().run({}).then(avukat => {
                        this.imzaLoginWaiting = false;
                        app.$store.commit('setUyapAvukatBilgileri',avukat);
                        return avukat;
                    }).catch((avukatErr) => {
                        // eslint-disable-next-line no-console
                        console.log("CATCH AVUKAT", avukatErr);
                        if (counter > 5) {
                            this.imzaLoginWaiting = false;
                            throw new Error('UYAP oturumuna erişilemedi.');
                        } else {
                            counter++;
                            window.setTimeout(() => {
                                checkSession();
                            }, 3000)
                        }
                    })
                }
                checkSession();
                // let cookies = await newAxios.get(avukatUyapUrl+'/getCookies');
                // let cookiesArr = JSON.parse(cookies.data).cookies.split('; ');
                // let jsessionId = cookiesArr.find((x:string)=>x.includes('JSESSIONID'));
                // window.sessionStorage.setItem("JSESSIONID", jsessionId);
                // app.$uyapHelper.setCookie("JSESSIONID", jsessionId.replace("JSESSIONID=", ""), 1);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log("ERROR", e);
                await axios.post('https://imza.eicrapro.com:6090/focus');
                if (e?.type == "pin")
                    localStorage.removeItem(e.serialNumber);
                if (e?.type == "unauthorized") {
                    await showWarningModal(
                        "İzinsiz İmza",
                        "Hesabınızda kayıtlı TC kimlik numarası ile e-İmza kartındaki TC kimlik numarası uyuşmamaktadır. Lütfen kendi hesabınızla giriş yapın ve size ait e-İmza kartını kullanın. Sorunun devam ettiğini düşünüyorsanız, Cloud ekranında Ctrl + Shift + R tuşlarına basarak sayfayı yenileyebilir ve tekrar deneyebilirsiniz."
                    );
                } else if (e.message && e.message.includes("Failed to execute 'atob'")) {
                    await showWarningModal(
                        "İmza Kartı Bulunamadı",
                        "İmza kartının bilgisayara takılı olduğundan ve sürücülerinin yüklü olduğundan emin olun."
                    );
                } else {
                    await showErrorModal(e.message, "Bir hata oluştu. Lütfen tekrar deneyin.");
                }
                this.imzaLoginWaiting = false;
                throw new Error(e.message);
            } finally {
                // İşlem bittiğinde lock’u sıfırla
                this.betaLoginPromise = null;
            }
        })();
        // Promise’i döndür
        return this.betaLoginPromise;
    }

    async fastBetaLogin() {
        try{
            let pinCodes = this.getPinCodes();
            //@ts-ignore
            let cardPin = pinCodes.find((item: any) => item.cardSerialNumber === store.getters.selectedCardSerial);
            if(cardPin){
                if(cardPin.autoLogin === true){
                    await this.betaLogin();
                }
            }
        }catch (e) {
            this.sendImzaMessage({
                title: "OTO LOGIN ERROR",
                text:  e.message,
                icon: "error",
                allowOutsideClick: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Tamam'
            });
        }
    }

    fastLogin(uyapPlatform: number) {
        return new Promise((s, f) => {
            if (this.imzaLoginWaiting == true)
                return f({message: this.waitingFailMessage});
            this.imzaLoginWaiting = true;
            axios.post(imzaciUrl + 'xml/sessionFast').then((response) => {
                const cookieSetUrl = proxyBaseUrl + uyapPlatform.toString() + '/cookie?' + window.atob(response.data) + ';SameSite=None;Secure';
                axios.post(cookieSetUrl).then(() => {
                    this.imzaLoginWaiting = false;
                    return s(response.data);
                });
            }).catch((e) => {
                if (e.message != this.waitingFailMessage) {
                    this.imzaLoginWaiting = false;
                }
                f(e);
            });
        });
    }

    mesajImzala() {
        const myXml = '<root>' +
            '<auth><token></token></auth>' +
            '<data><message>Emre deneme imzala</message></data>' +
            '</root>';
        //readResult = reader.result.split(',')[1];
        axios.post(imzaciUrl + "xml/mesajImzala", myXml, {
            headers: {
                "Content-Type": "application/xml;charset=UTF-8"
            }
        })
    }



    icrapro80VeriAktar(dosyaEsasNo: any, icraDairesi: any, kartId: any, klasor: any) {
        return new Promise((resolve, reject) => {
            const xml = "<dosyaEsasNo>" + dosyaEsasNo + "</dosyaEsasNo><icraDairesi>" + icraDairesi + "</icraDairesi><kartId>" + kartId + "</kartId><icraproKlasor>" + klasor + "</icraproKlasor>";
            let myXml = "<root>\n" +
                "<auth>\n" +
                "<token></token>\n" +
                "<hash></hash>\n" +
                "</auth>\n" +
                "<data>\n" +
                "<b64Xml>" + Mixins.utf8_to_b64(xml) + "</b64Xml>\n" +
                "</data>\n" +
                "</root>"
            axios.post(imzaciUrl + 'xml/setDosyaEsasNo', myXml, {
                headers: {
                    "Content-Type": "application/xml;charset=UTF-8"
                }
            }).then((data) =>{
                return resolve(data)
            }).catch((err)=>{
                return reject(err);
            });
        })
    }

    dokumanImzala(data: Blob) {
        return new Promise((resolve, reject) => {
            if (this.simulator) {
                resolve("");
                return;
            }
            const reader = new FileReader();
            reader.readAsDataURL(data); //udf base64 ceviriliyor..
            reader.onloadend = function () {
                //console.log("reader Result",reader.result);
                let b64Udf;
                if (typeof reader.result == "string") {
                    b64Udf = reader.result.split(',')[1];
                } else {
                    return reject('Dosya okunurken hata oluştu');
                }
                //console.log("b64UDF", b64Udf);

                //127.0.0.1:4723/xml/dokumanImzala
                //* blob data reader ile base 64 e ceviriliyor imzaciya gonderiliyor...

                const myXml = '<root>' +
                    '<auth><token></token></auth>' +
                    '<data><code>' + b64Udf + '</code></data>' +
                    '</root>';
                //readResult = reader.result.split(',')[1];
                axios.post(imzaciUrl + "xml/b64imzala", myXml, {
                    headers: {
                        "Content-Type": "application/xml;charset=UTF-8"
                    }
                }).then((data) => {
                    let parseString = xml2js.parseString;
                    parseString(data.data, {explicitArray: false}, (error: Error | null, result: any) => {
                        if (error) {
                            return reject(error);
                        }
                        //console.log("RESULT IMZALANMA", result);
                        return resolve(result.root.file);
                    });
                }).catch(function (err) {
                    if (err.response) {
                        let parseString = xml2js.parseString;
                        parseString(err.response.data, {explicitArray: false}, (error: Error | null, result: any) => {
                            app.$toast.error("Hata Kodu " + err.response.status + ": " + result.root.error_title);
                        });
                    } else if (err.request) {
                        app.$toast.error("İmzacı bağlantı hatası.");
                    } else {
                        app.$toast.error("Bilinmeyen hata (" + err.message + ")");
                    }
                    return reject(err);
                });

            };
        });
    }

    getFileFromLocalPath(path: string) {
        return new Promise((resolve, reject) => {
            let myXml = "<root>\n" +
                "<auth>\n" +
                "<token></token>\n" +
                "<hash></hash>\n" +
                "</auth>\n" +
                "<data>\n" +
                "<b64Xml>" + Mixins.utf8_to_b64("<path>" + path + "</path>") + "</b64Xml>\n" +
                "</data>\n" +
                "</root>"
            axios.post(imzaciUrl + "xml/getXmlContent", myXml, {
                headers: {
                    "Content-Type": "application/xml;charset=UTF-8"
                }
            }).then((data) => {
                let replacedData = String(data.data).replace(/\n/g, "");
                let parseString = xml2js.parseString;
                parseString(replacedData, {explicitArray: false}, (error: Error | null, jsonData: any) => {
                    if (error) {
                        return reject(error);
                    }
                    if (typeof jsonData.root.file != "undefined") {
                        return resolve(jsonData.root);
                    } else {
                        return reject({message: "Dosya bulunamadı !"});
                    }
                });
            }).catch(err => {
                return reject(err);
            })
        });
    }

    serialize(obj: any) {
        let str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

}

export default function ImzaClientPlugin(Vue: typeof _Vue): void {
    // do stuff with options
    Vue.prototype.$imza = new ImzaClient();
}
